import { Suspense, lazy, useEffect } from "react";
import { RenderLoadingSpinnerInImageTag } from "./Helper";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Settings from "./Components/Profile/Settings";
import CreateDataBaseAndApiKey from "./Components/Profile/CreateDataBaseAndApiKey";

import { useScrollToTop } from "../../Utility";
import {
  fetchUserProfile,
  setDefaultProfileState,
} from "../../features/Api/userProfile";
import {
  setRefreshTokenInValid,
  setUserProfileInfo,
} from "../../features/UserLoginStatusSlice";
import { setDisplayAlertForRefreshInValid } from "../../features/DisplayAlertRefreshInValidSlice";

// * import method different because its a lazy load import
const Header = lazy(() => import(`./Components/Profile/Header`));
const ProfileNav = lazy(() => import(`./Components/Profile/ProfileNav`));
const Overview = lazy(() => import(`./Components/Profile/Overview`));
const ProfileInfo = lazy(() => import(`./Components/Profile/ProfileInfo`));

export default function Account() {
  // * At the top of the page.
  useScrollToTop();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // * Page location
  const location = useLocation();
  const currentPath = location.pathname;

  // * Start ***Enable Dark Mode Feature***
  const darkModeState = useSelector((state) => state.setMode).darkMode;
  const accountBackGroundDynamic = useSelector((state) => state.setMode).css
    ?.accountPageBackground;

  // * Display components
  function handelReturnMainComponent(pathname) {
    const returnComponent = (component, loadingMsg) => {
      return (
        <Suspense
          fallback={RenderLoadingSpinnerInImageTag("w-20", "h-20", loadingMsg)}
        >
          {component}
        </Suspense>
      );
    };

    switch (pathname) {
      case "/account/profile/overview":
        return returnComponent(<Overview />, "Lodging Profile overview");
      case "/account/profile/info":
        return returnComponent(<ProfileInfo />, "Lodging Profile info");
      case "/account/profile/settings":
        return returnComponent(<Settings />, "Lodging Profile Settings");
      case "/account/profile/database-api-key":
        return returnComponent(
          <CreateDataBaseAndApiKey />,
          "Lodging Database and api key page"
        );
      default:
        return returnComponent(<ProfileInfo />, "Lodging Profile info");
    }
  }
  //  * Tack action when refresh token invalid
  const serverResStatusCode = useSelector(
    (state) => state.userProfileInfo
  ).statusCode;
  const userProfileInfoResponse = useSelector(
    (state) => state.userProfileInfo
  ).response;

  // * Call api for get user profile info
  useEffect(() => {
    dispatch(fetchUserProfile());
    shallowEqual();
  }, [dispatch]);

  // ! If refresh token invalid
  useEffect(() => {
    if (serverResStatusCode === 401) {
      dispatch(setRefreshTokenInValid()); // ? Common set refresh toke invalid
      dispatch(setDisplayAlertForRefreshInValid()); // ? Common display alert
      dispatch(setDefaultProfileState()); // ? [Specific]
      navigate("/login");
      window.location.reload(); // # Reloading the page to reset the application state.
    }
    if (serverResStatusCode === 200) {
      dispatch(setUserProfileInfo(userProfileInfoResponse));
    }
  }, [dispatch, navigate, serverResStatusCode, userProfileInfoResponse]);

  //  * Tack action when refresh token invalid \\\
  return (
    <>
      {/* Header */}
      <header>
        <Suspense
          fallback={RenderLoadingSpinnerInImageTag(
            "w-20",
            "h-20",
            "Header Lodging"
          )}
        >
          <Header />
        </Suspense>
      </header>

      <div className={` min-h-screen ${accountBackGroundDynamic}`}>
        {/* Nav control and other body */}
        <div className={`flex flex-wrap  `}>
          <nav
            className={`bg-[#001e2b] h-fit md:h-auto basis-full md:basis-1/5 lg:basis-1/6 ${
              darkModeState ? " bg-[#001e2b] " : " bg-[#f9fbfa] "
            }`}
          >
            <Suspense
              fallback={RenderLoadingSpinnerInImageTag(
                "w-20",
                "h-20",
                "Lodging Nav Control"
              )}
            >
              <ProfileNav />
            </Suspense>
          </nav>

          {/* Content {Body} */}
          <div
            className={` account-Page-Body min-h-screen max-h-screen overflow-y-scroll basis-full md:basis-4/5 lg:basis-10/12 `}
          >
            {/* Return here "Overview / Profile / Settings" */}
            {handelReturnMainComponent(currentPath)}
          </div>
        </div>
      </div>
    </>
  );
}
